'use client'

import { PrismicRichText } from "@prismicio/react";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

const SideMenu = ({ content, isMobileViewer }) => {

  useEffect(() => {
    const $sumUpTrigger = Array.from(document.querySelectorAll('.sumup-trigger'));
    if ($sumUpTrigger !== null) obeserveSubMenu($sumUpTrigger);
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  function goToSection(e) {
    const text = e.target.dataset.pointer;

    setIsOpen(false);

    setTimeout(() => {
      const d = document.getElementById(text);
      if (d) {
        window.scrollTo({
          behavior: 'smooth',
          top:
            d.getBoundingClientRect().top -
            document.body.getBoundingClientRect().top -
            130,
        });
      }
    }, 100);
  }
  function obeserveSubMenu(elems) {
    const obs = {
      rootMargin: '',
      threshold: 1,
    };

    function cb(entries) {
      entries.forEach(entry => {
        if (!isMobileViewer) {
          if (entry.isIntersecting) {
            document.querySelectorAll(".article-sumup-title").forEach(e => e.classList.add("text-sumup-active"));
            document.querySelector(`[data-pointer="${entry.target.id}"]`).classList.remove("text-sumup-active");
          }
        }
      });
    }
    const observer = new IntersectionObserver(cb, obs);
    elems.forEach(element => observer.observe(element));
  }

  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth < 1024) {
        const scrollPosition = window.innerHeight + window.scrollY;
        const bottomPosition = document.body.offsetHeight;

        if (bottomPosition - scrollPosition < window.innerHeight * 3) {
          setIsAtBottom(true);
        } else {
          setIsAtBottom(false);
        }
      } else {
        setIsAtBottom(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  return (
    <div className="w-full h-full pointer-events-none lg:pointer-events-auto">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.1, ease: "easeInOut" }}
            className="fixed inset-0 bg-black z-40 cursor-pointer lg:hidden"
            onClick={() => setIsOpen(false)}
          />
        )}
      </AnimatePresence>

      {/* Version mobile */}
      <div className={`sumup-wrapper lg:hidden sticky top-20 pointer-events-auto z-50 transition-opacity duration-300 ${isAtBottom ? 'opacity-0' : 'opacity-100'}`}>
        <div
          className={`flex justify-between items-center bg-dark-beige p-2 transition-all duration-300 ${isOpen ? "rounded-b-0 rounded-t-[20px]" : "rounded-[30px]"
            }`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="tags text-tags">Sommaire</span>
          <img
            src="/arrow-blue.svg"
            alt="flèche"
            className={`transition-transform mr-2 w-[14px] h-[24px] ${isOpen ? "-rotate-90" : "rotate-90"}`}
          />
        </div>

        <AnimatePresence initial={false}>
          {isOpen && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="overflow-hidden bg-[#FFEEE0] rounded-b-[30px] px-5 pb-2"
            >
              <PrismicRichText
                field={content.filter(el => el.type === 'heading2')}
                components={{
                  heading2: ({ children, text }) => (
                    <div className="my-3.5" onClick={goToSection}>
                      <h4
                        data-pointer={`${text
                          .split(" ")
                          .join("-")
                          .split("'")
                          .join("-")
                          .split(":")
                          .join("")
                          .split("(")
                          .join("")
                          .split(")")
                          .join("")
                          .split("--")
                          .join("-")}`}
                        className="cursor-pointer article-sumup-title transition-opacity text-sumup"
                      >
                        {children}
                      </h4>
                    </div>
                  ),
                }}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {/* Version desktop */}
      <div className="sumup-wrapper bg-dark-beige px-6 pt-4 pb-2 rounded-[30px] sticky top-28 mb-24 hidden lg:block">
        <img src="/spikes-double-red.svg" alt="décoration" className="h-[34px] w-auto absolute top-0 right-8" />
        <span className="tags text-tags">Sommaire</span>
        <PrismicRichText
          field={content.filter(el => el.type === 'heading2')}
          components={{
            heading2: ({ children, text }) => (
              <div className="my-3.5" onClick={goToSection}>
                <h4
                  data-pointer={`${text
                    .split(" ")
                    .join("-")
                    .split("'")
                    .join("-")
                    .split(":")
                    .join("")
                    .split("(")
                    .join("")
                    .split(")")
                    .join("")
                    .split("--")
                    .join("-")}`}
                  className="cursor-pointer article-sumup-title transition-opacity text-sumup"
                >
                  {children}
                </h4>
              </div>
            ),
          }}
        />
      </div>
    </div>
  );
}

export default SideMenu;
